import React, { Suspense, lazy } from 'react';
import { LocaleProvider } from '../utils/locale';
import { HeroSection } from '../components/HeroSection';
import { CellularResetSection } from '../components/CellularResetSection';
const WowMomentSection = lazy(() => import('../components/WowMomentSection').then(m => ({
  default: m.WowMomentSection
})));
const MirrorSection = lazy(() => import('../components/MirrorSection').then(m => ({
  default: m.MirrorSection
})));
const VillainSection = lazy(() => import('../components/VillainSection').then(m => ({
  default: m.VillainSection
})));
const SymptomsSection = lazy(() => import('../components/SymptomsSection').then(m => ({
  default: m.SymptomsSection
})));
const MechanismSection = lazy(() => import('../components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const FascinationsSection = lazy(() => import('../components/FascinationsSection').then(m => ({
  default: m.FascinationsSection
})));
const TwoPathsSection = lazy(() => import('../components/TwoPathsSection').then(m => ({
  default: m.TwoPathsSection
})));
const AuthorityStatementSection = lazy(() => import('../components/AuthorityStatementSection').then(m => ({
  default: m.AuthorityStatementSection
})));
const SocialProofSection = lazy(() => import('../components/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const FinalCtaSection = lazy(() => import('../components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const SafetyNetSection = lazy(() => import('../components/SafetyNetSection').then(m => ({
  default: m.SafetyNetSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
export function LandingPageUS() {
  return <LocaleProvider locale="us" data-id="element-423">
      <HeroSection data-id="element-424" />
      <CellularResetSection data-id="element-425" />
      <Suspense fallback={null} data-id="element-426">
        <WowMomentSection data-id="element-427" />
        <MirrorSection data-id="element-428" />
        <VillainSection data-id="element-429" />
        <SymptomsSection data-id="element-430" />
        <MechanismSection data-id="element-431" />
        <FascinationsSection data-id="element-432" />
        <TwoPathsSection data-id="element-433" />
        <AuthorityStatementSection data-id="element-434" />
        <SocialProofSection data-id="element-435" />
        <FinalCtaSection data-id="element-436" />
        <SafetyNetSection data-id="element-437" />
        <Footer data-id="element-438" />
      </Suspense>
    </LocaleProvider>;
}